import { IconType } from "react-icons/lib";

interface SectionProps {
    title: string;
    icon: IconType;
    children: React.ReactNode;
    footer?: React.ReactNode;
}



export const Section: React.FC<SectionProps> = (props) => {

    const renderSectionHeader = () =>{
        return (
            <div className="section-title">
                <div className="header-section-icon">
                    <props.icon />
                </div>
                <div>
                    <h2>{props.title}</h2>
                </div>
            </div>
        )
    }

    const renderSectionBody = () => {
        return (
            <div>
                {props.children}
            </div>
        )
    }
    const renderSectionFooter = () => {
        return (
            <div>
                {props.footer}
            </div>
        )
    }

    return (
        
        <div>
            {renderSectionHeader()}
            <div className="section-content-gc">
                {renderSectionBody()}
                {props.footer && renderSectionFooter()}
            </div>
        </div>
    );
};
